import { useMemo } from 'react';

import { useAppState } from '../../AppStateProvider';
import { Page } from '../../domain/page';

export const useIsMultipleDomainsPage = () => {
  const { page } = useAppState();

  const isMultipleDomainsPage = useMemo(
    () => page === Page.Meeting || page === Page.Email || page === Page.GoogleSheets,
    [page]
  );

  return isMultipleDomainsPage;
};
